import React, { useState, useRef, useEffect } from 'react';

const periods = [
  { value: 'this_week', label: 'This Week' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'last_month', label: 'Last 30 Days' },
  { value: 'last_3_months', label: 'Last 3 Months' },
  { value: 'last_6_months', label: 'Last 6 Months' },
  { value: 'all_time', label: 'All Time' },
];

export function PeriodSelector({ value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const selectedPeriod = periods.find((p) => p.value === value) || periods[2];

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (periodValue) => {
    onChange(periodValue);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between w-48 px-4 py-2 bg-coros-bg-primary border border-coros-border rounded-lg text-coros-text-primary hover:bg-coros-bg-secondary transition-colors"
      >
        <span>{selectedPeriod.label}</span>
        <svg
          className={`w-4 h-4 ml-2 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-48 bg-coros-bg-primary border border-coros-border rounded-lg shadow-xl z-10 overflow-hidden">
          {periods.map((period) => (
            <button
              key={period.value}
              onClick={() => handleSelect(period.value)}
              className={`w-full px-4 py-2 text-left text-sm hover:bg-coros-bg-tertiary transition-colors flex items-center justify-between ${
                period.value === value ? 'bg-coros-bg-tertiary text-coros-text-primary' : 'text-coros-text-secondary'
              }`}
            >
              <span>{period.label}</span>
              {period.value === value && (
                <svg className="w-4 h-4 text-coros-red" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default PeriodSelector;
